import _default from './Divider';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Divider/index.js
// module id = 650
// module chunks = 0